export default __webpack_public_path__ + "static/media/me2.6ca03b37.gif";